// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1Cx8F","legacyBtn":"MutateMid_legacyBtn__1Sip6"};